// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"b5f841a2","318":"087b7ffa","331":"83d30a9b"}[chunkId] + ".chunk.js";
};